import { TreeNode } from 'primeng/primeng';

export class DeptTreeNode implements TreeNode {
  label?: string;
  data?: any;
  icon?: string;
  children?: DeptTreeNode[];
  type?: string;
  expanded?: boolean;
  expandedIcon?: any;
  collapsedIcon?: any;
  leaf?: boolean;
  parent?: TreeNode;
  partialSelected?: boolean;
  styleClass?: string;
  draggable?: boolean;
  droppable?: boolean;
  selectable?: boolean;
  isDept: boolean;
  deptId: number;

  // todo deptåºè¯¥æ¯ä¸ä¸ªç¡®å®ç±»åçå®ä¾
  constructor(dept: any) {
    this.label = dept.name;
    this.data = dept;
    this.deptId = dept.id;
    this.children = [];
    this.isDept = dept.hasOwnProperty('parentId');
    this.icon = this.isDept ? 'nec-icon-dept' : 'nec-icon-group';
  }
}
